jQuery( function ( $, undefined ) {
	var	$converter = $( '.kl-converter__calc' ),
		$results = $( '.kl-converter__results' ),
		$results_list = $( '.kl-converter__results-list' ),
		$ingredient = $( '[name="converter-ingredient"]' ),
		$value = $( '[name="converter-value"]' ),
		$units = $( '[name="converter-unit"]' ),
		$result_clone = $results.find( '.kl-converter__results__result' ).clone(),
		current_unit, current_value, available_units;

	if ( 1 > $converter.length ) {
		return;
	}

	$ingredient.on( 'change', function () {
		var $this = $( this ),
			has_ml = false,
			has_g = false,
			new_ingredient, units, new_options, option;

		new_ingredient = $this.val();
		$units.find( 'option' ).not( ':first' ).remove();
		$results.hide().find( '.kl-converter__results__result' ).remove();

		if ( ! new_ingredient ) {
			available_units = undefined;
			return;
		}

		units = $this.find( '[value="' + new_ingredient + '"]' ).data( 'przelicznik' );
		new_options = document.createDocumentFragment();
		available_units = units;

		$.each( units, function ( index, element ) {
			option = document.createElement( 'option' );

			if ( 'ml' === element.jednostka ) {
				option.text = 'mililitrów';
			} else if ( 'g' === element.jednostka ) {
				option.text = 'gramów';
			} else {
				option.text = element.jednostka;
			}

			option.value = element.jednostka;
			$( option ).data( 'unit', element ).appendTo( new_options );
		});

		$units.append( new_options );
	});

	$units.on( 'change', function () {
		var val = $( this ).val();
		current_unit = val ? $units.find( '[value="' + val + '"]' ).data( 'unit' ) : undefined;
	});

	$value.on( 'change keyup', function () {
		var val = $( this ).val();
		current_value = val ? parseFloat( val ) : undefined;
	});

	$converter.on( 'change keyup', function () {
		if ( current_value && current_unit && available_units ) {
			output_results();
		}
	});

	$( '.kl-converter-unit-switch--next' ).on( 'click', function ( e ) {
		e.preventDefault();

		var $select = $( this ).siblings( 'select' ).first();

		$select.val( function () {
			var $option = $select.find( '[value="' + $select.val() + '"]' ).next( 'option' );

			if ( 1 > $option.length ) {
				$option = $select.find( 'option' ).first();
			}

			return $option.attr( 'value' );
		}).removeClass( 'kl--with-icon-szklanka kl--with-icon-łyżka kl--with-icon-łyżeczka' );

		if ( $select.val() ) {
			$select
				.addClass( 'kl--with-icon-' + $select.val() );
		}
	});

	$( '.kl-converter-unit-switch--prev' ).on( 'click', function ( e ) {
		e.preventDefault();

		var $select = $( this ).siblings( 'select' ).first();

		$select.val( function () {
			var $option = $select.find( '[value="' + $select.val() + '"]' ).prev( 'option' );

			if ( 1 > $option.length ) {
				$option = $select.find( 'option' ).last();
			}

			return $option.attr( 'value' );
		}).removeClass( 'kl--with-icon-szklanka kl--with-icon-łyżka kl--with-icon-łyżeczka' );

		if ( $select.val() ) {
			$select
				.addClass( 'kl--with-icon-' + $select.val() );
		}
	});

	function get_noun( noun, count ) {
		var strCount;

		count = count || 1;

		if ( 'g' === noun.toLowerCase() ) {
			noun = 'gram';
		} else if ( 'ml' === noun.toLowerCase() ) {
			noun = 'mililitr';
		}

		if ( 1 === count ) {
			return noun;
		}

		if ( 'szklanka' === noun.toLowerCase() ) {
			strCount = Math.floor( count ).toString();

			if ( -1 !== $.inArray( strCount.charAt( strCount.length - 1 ), [ "2", "3", "4" ] ) && -1 === $.inArray( count, [ 12, 13, 14 ] ) ) {
				return 'szklanki';
			} else {
				return 'szklanek';
			}
		} else if ( 'łyżka' === noun.toLowerCase() ) {
			strCount = Math.floor( count ).toString();

			if ( -1 !== $.inArray( strCount.charAt( strCount.length - 1 ), [ "2", "3", "4" ] ) && -1 === $.inArray( count, [ 12, 13, 14 ] ) ) {
				return 'łyżki';
			} else {
				return 'łyżek';
			}
		} else if ( 'łyżeczka' === noun.toLowerCase() ) {
			strCount = Math.floor( count ).toString();

			if ( -1 !== $.inArray( strCount.charAt( strCount.length - 1 ), [ "2", "3", "4" ] ) && -1 === $.inArray( count, [ 12, 13, 14 ] ) ) {
				return 'łyżeczki';
			} else {
				return 'łyżeczek';
			}
		} else if ( 'gram' === noun.toLowerCase() ) {
			strCount = Math.floor( count ).toString();

			if ( -1 !== $.inArray( strCount.charAt( strCount.length - 1 ), [ "2", "3", "4" ] ) && -1 === $.inArray( count, [ 12, 13, 14 ] ) ) {
				return 'gramy';
			} else {
				return 'gramów';
			}
		} else if ( 'mililitr' === noun.toLowerCase() ) {
			strCount = Math.floor( count ).toString();

			if ( -1 !== $.inArray( strCount.charAt( strCount.length - 1 ), [ "2", "3", "4" ] ) && -1 === $.inArray( count, [ 12, 13, 14 ] ) ) {
				return 'mililitry';
			} else {
				return 'mililitrów';
			}
		}

		return noun;
	}

	function convert( value, from, to ) {
		var converted_value, multiplier;

		if ( from.jednostka === to.jednostka ) {
			multiplier = 1;
		} else if ( from.jednostka_przeliczenia === to.jednostka ) {
			multiplier = from.przeliczenie;
		} else if ( from.jednostka_przeliczenia === to.jednostka_przeliczenia ) {
			multiplier = from.przeliczenie / to.przeliczenie;
		} else if ( to.jednostka_przeliczenia === from.jednostka ) {
			multiplier = 1 / convert( 1, to, from ).value;
		}

		converted_value = value * multiplier;

		if ( -1 < $.inArray( to.jednostka, [ 'łyżka', 'łyżeczka' ] ) ) {
			converted_value = Math.round( converted_value );
		}

		return {
			value: converted_value,
			unit: to.jednostka
		};
	}

	function output_results() {
		try {
			$results_list.slick('unslick');
		} catch (e) {}

		if ( ! available_units ) {
			$results.hide();
			return;
		}

		var title = current_value + ' ' + get_noun( current_unit.jednostka, current_value ) + ' ' + $ingredient.find( '[value="' + $ingredient.val() + '"]' ).data( 'dopelniacz' ) + ' to';
		var conversions = [];
		var skip = current_unit.jednostka_przeliczenia;

		conversions.push( convert( current_value, current_unit, {
			jednostka: current_unit.jednostka_przeliczenia,
			przeliczenie: 1,
			jednostka_przeliczenia: current_unit.jednostka_przeliczenia
		}));

		$.each( available_units, function ( index, element ) {
			if ( current_unit.jednostka === element.jednostka ) {
				return true;
			}

			if ( skip === element.jednostka ) {
				return true;
			}

			var converted = convert( current_value, current_unit, element );

			conversions.push( converted );
		});


		if ( conversions ) {
			$results.find( '.kl-converter__results__title' ).text( title );
			$results.find( '.kl-converter__results__result' ).remove();

			$.each( conversions, function ( index, element ) {
				if ( ! element || ! element.value ) {
					return true;
				}

				$result_clone
					.clone()
						.find( '.kl-converter__results__result__value' )
						.text( element.value.toLocaleString( 'pl', { maximumFractionDigits: 2 } ) )
						.end()
					.attr( 'data-initial', element.unit.charAt(0) )
					.append( get_noun( element.unit, element.value ) )
					.appendTo( $results_list );
			});

			$results.show();
			initialize_slick();
		} else {
			$results.hide();
		}
	}

	function initialize_slick() {
		$results_list.slick({
			slidesToShow: 1,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: "unslick"
				}
			]
		});
	}
});

jQuery( function ( $ ) {
	var $numfields = $( '.kl-converter__field[type="number"]' ),
		$buttons;

	if ( 1 > $numfields.length ) {
		return;
	}

	$buttons = $( '<button class="kl-btn-more">' + dklI18n.more + '</button><button class="kl-btn-less">' + dklI18n.less + '</button>' );

	$numfields.each( function ( index, element ) {
		var $this = $( this );
		$this.wrap( '<span class="kl-converter__field-wrapper"></span>' ).after( $buttons );
	});

	$numfields.closest( 'span' ).on( 'click.delektujemy', '.kl-btn-more', function ( e ) {
		var $field = $( this ).closest( 'span' ).find( 'input[type="number"]' ),
			val = parseInt( $field.val(), 10 );

		e.preventDefault();

		if ( isNaN( val ) ) {
			val = 0;
		}

		$field.val( val + 1 ).trigger( 'change' );
	}).on( 'click.delektujemy', '.kl-btn-less', function ( e ) {
		var $field = $( this ).closest( 'span' ).find( 'input[type="number"]' ),
			val = parseInt( $field.val(), 10 );

		e.preventDefault();

		if ( isNaN( val ) ) {
			val = 0;
		}

		$field.val( Math.max( val - 1, 0 ) ).trigger( 'change' );
	});
});
